<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <button-link
          type="success"
          to="/punishment_orders/create"
        >
          <slot>添加罚单</slot>
        </button-link>
      </div>
    </div>

    <el-table
      :data="punishment_orders"
      resource="punishment_orders"
    >
      <el-table-column
        prop="no"
        label="订单编号"
        min-width="120"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="area_name"
        label="区域"
        align="center"
        min-width="100"
        show-overflow-tooltip
      />
        <!-- <el-table-column
          prop="name"
          label="名称"
          min-width="6%"
          show-overflow-tooltip
          align="center"
        /> -->
        <!--      <el-table-column-->
        <!--        prop="user_name"-->
        <!--        label="用户名"-->
        <!--        min-width="100"-->
        <!--        align="center"-->
        <!--        show-overflow-tooltip-->
        <!--      />-->
        <el-table-column
        prop="user_mobile"
        label="用户手机"
        min-width="100"
        align="center"
      />
      <el-table-column
        prop="bike_no"
        label="车辆编号"
        min-width="100"
        align="center"
      />
      <el-table-column
        prop="order_no"
        label="骑行订单编号"
        min-width="120"
        align="center"
        show-overflow-tooltip
      />

      <el-table-column
        prop="pay_money"
        label="支付金额"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.pay_money }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="pay_time"
        label="支付时间"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="pay_type"
        label="支付类型"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.pay_status == 0"
            type="danger"
          >{{ scope.row.pay_type }}</el-tag>
          <el-tag
            v-else
            type="success"
          >{{ scope.row.pay_type }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="occurrence_time"
        label="事件时间"
        min-width="120"
        align="center"
      />
      <el-table-column
        label="操作"
        width="200"
        align="center"
      >
        <template #default="{ row}">
          <el-button-group>
            <row-to-edit v-show="row.pay_status == 0" />
            <row-destroy v-show="row.pay_status == 0" />
            <!-- <el-button type="success" @click="dialogVisibleClick(row)" size="small">送卡</el-button> -->
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getPunishmentOrder } from "@/api/punishment_order";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    return {
      dialogVisible: false,
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "name",
          label: "名称"
        },
        {
          field: "no",
          label: "订单编号"
        },
        {
          field: "order_no",
          label: "骑行订单编号"
        },
        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        }
      ],
      punishment_orders: [],
      page: null,
      first_blood: true,

      card_name: "",
      areas: []
    };
  },
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.areas = areas;
    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[5].options.push.apply(
          this.search[5].options,
          merchant.data
        );
      }
    }
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getPunishmentOrder(newVal.query);
        this.punishment_orders = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
